import { errorToastClassName, appToast as toast } from "@/components/ui/baseUi/sonner"
import { useTaxes } from "@/modules/finances/taxes/hooks/useTaxes"
import { useStripePlatform } from "@/modules/payment/hooks/useStripePlatform"
import { useCurrentBox } from "@modules/box/hooks/useBox"
import { i18n, word } from "@modules/core/utils/i18n"
import { TaxSettingsStatus } from "@modules/finances/gateway/taxesDto"
import { loadConnectAndInitialize, type StripeConnectInstance } from "@stripe/connect-js"
import { useEffect, useState } from "react"

export const useStripeConnectInstance = () => {
  const { getTaxRegistrationToken } = useTaxes()
  const { result: box } = useCurrentBox()
  const [connectInstance, setConnectInstance] = useState<StripeConnectInstance | null>(null)
  const { getStripePublicKey } = useStripePlatform()

  useEffect(() => {
    if (connectInstance) {
      return
    }

    if (box && box.taxStatus === TaxSettingsStatus.ACTIVE) {
      getStripePublicKey(box.stripePlatform)
        .then((publishableKey) => {
          setConnectInstance(
            loadConnectAndInitialize({
              publishableKey,
              fetchClientSecret: getTaxRegistrationToken,
              locale: i18n.locale,
              appearance: {
                variables: {
                  colorSecondaryText: "#B3B4B1",
                  colorText: "#FFFFFF",
                  colorPrimary: "#6450F7",
                  colorBackground: "#1C1C1C",
                  actionPrimaryColorText: "#FFFFFF",
                  buttonSecondaryColorBackground: "#2B3039",
                  buttonSecondaryColorText: "#C9CED8",
                  actionSecondaryColorText: "#C9CED8",
                  actionSecondaryTextDecorationColor: "#C9CED8",
                  colorBorder: "#2B3039",
                  colorDanger: "#F23154",
                  badgeNeutralColorBackground: "#1B1E25",
                  badgeNeutralColorBorder: "#2B3039",
                  badgeNeutralColorText: "#8C99AD",
                  badgeSuccessColorBackground: "#152207",
                  badgeSuccessColorBorder: "#20360C",
                  badgeSuccessColorText: "#3EAE20",
                  badgeWarningColorBackground: "#400A00",
                  badgeWarningColorBorder: "#5F1400",
                  badgeWarningColorText: "#F27400",
                  badgeDangerColorBackground: "#420320",
                  badgeDangerColorBorder: "#61092D",
                  badgeDangerColorText: "#F46B7D",
                  offsetBackgroundColor: "#1B1E25",
                  formBackgroundColor: "#14171D",
                  overlayBackdropColor: "rgba(0,0,0,0.5)",
                },
              },
            }),
          )
        })
        .catch((error: unknown) => {
          console.error(error)
          setConnectInstance(null)
          toast.error(word("global.error.default"), {
            classNames: errorToastClassName(),
          })
        })
    }
  }, [box?.taxStatus, getTaxRegistrationToken, connectInstance])

  return connectInstance
}
